//import * as lib from '../lib/lib'
import $ from 'jquery';

const viewportCheckpoint = 0.25
class StickyText {
    constructor(element) {
        if (!element) return

        this.element = element

      
        this.cont = $(this.element)
        this.title = $(this.element).find(".s-sticky-text__title")
        this.text =  $(this.element).find(".s-sticky-text__cont")

       
        // this.setTitleSize()
        // this.checkTitlePosition()

        // $(window).on("scroll", (_) => {
        //     console.log('start scroll')
        //     this.checkTitlePosition()
        //   })
      
        //   $(window).on("resize", (_) => {
        //     this.setTitleSize()
        //     this.checkTitlePosition()
        //   })
       
    }

   
    setTitleSize() {
        const titleSize = this.title.width()
        this.title.css("width", titleSize + "px")
    
        this.titleHeight = this.title.height()
        this.textHeight = this.text.height()
      }

      checkTitlePosition() {
        // const winW = $(window).outerWidth()
         const winH = $(window).outerHeight()
         const winTop = $(window).scrollTop()
         const headerH = $(".header").outerHeight()


        const stickyPosition = headerH + 
                               (winH - headerH) * 
                               viewportCheckpoint
    
        const stickyStart = this.cont.offset().top
        const stickyEnd = stickyStart + this.cont.outerHeight()

        console.log(winTop + stickyPosition < stickyStart) 
        console.log(winTop , stickyPosition , stickyStart) 

    
        if (this.titleHeight > this.textHeight) {
          this.title.css({position :"static"})
        } else {
          if (winTop + stickyPosition >
            stickyStart && winTop + stickyPosition + this.titleHeight < stickyEnd) {
            this.title.css({
              position: "fixed",
              top: stickyPosition + "px"
            })
          } else {
            if (winTop + stickyPosition < stickyStart) {
              this.title.css({
                position: "absolute",
                top: 0,
                bottom: "auto"
              })
            } else if (winTop + stickyPosition + this.titleHeight >= stickyEnd) {
              this.title.css({
                position: "absolute",
                top: "auto",
                bottom: 0
              })
            }
          }
        }
      }
    
}

export default StickyText
